<template>
  <!-- img alt="Vue logo" src="./assets/logo.png" -->
  <div class="overflow-x-clip ">
    <div>
      <TopBar v-if="!$route.meta.hideTopBar" theme="light"></TopBar>
      <router-view></router-view>
      <BtmBar />
    </div>
  </div>
</template>

<script>
//import MainPage from './components/MainPage.vue'
import BtmBar from './components/BtmBar.vue';

import TopBar from './components/TopBar.vue';

export default {
  name: 'App',
  components: {

    BtmBar,
    TopBar,
  },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}
</style>
